import { startTransition, useEffect, useState } from 'react';

import useSidebarStore from '@/components/sidebar/hooks/useSidebarStore';
import useApiErrorStatus from '@/hooks/useApiErrorStatus';
import { useGetSignalen } from '@/queries/signalen/useGetSignalen';
import useSignalen from '@/state/selectors/useSignalen';
import useClientState from '@/state/useClientState';

import PanelHeader from '../stickyPanelHeader/PanelHeader';

import { SignalenFilterDialog } from './signalenFilter/SignalenFilterDialog';
import { defaultFilter } from './signalenFilter/signalenFilterModel';
import SignalenLijst from './SignalenLijst';

import styles from './Signalen.module.css';

const useSyncSignalenUitBackendEenmaligMetClientState = () => {
  const { data, isError, isSuccess, errorUpdateCount } = useGetSignalen();
  const { handleApiStatus } = useApiErrorStatus();
  const vervangAlleSignalen = useClientState((state) => state.vervangAlleSignalen);

  useEffect(() => {
    if (data) {
      startTransition(() => {
        vervangAlleSignalen(data);
      });
    }
  }, [data, vervangAlleSignalen]);

  useEffect(() => {
    handleApiStatus('alleSignalen', isError && !isSuccess);
  }, [isError, isSuccess, errorUpdateCount]);
};

function Signalen({ panelMenuInformation }) {
  useSyncSignalenUitBackendEenmaligMetClientState();
  const { signalenView: data } = useSignalen();
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const currentFilter = useSidebarStore((state) => state.signalenFilter);
  const setCurrentFilter = useSidebarStore((state) => state.setSignalenFilter);

  return (
    <div className={styles.signalenStyle}>
      <PanelHeader
        title='Signalen'
        sectionId='signalen'
        onFilterMenuItemClick={() => setShowFilterDialog(true)}
        filterActive={currentFilter !== defaultFilter}
      />
      <SignalenLijst signalen={data ?? []} filter={currentFilter} panelMenuInformation={panelMenuInformation} />
      {showFilterDialog && (
        <SignalenFilterDialog
          showDialog={showFilterDialog}
          handleOpenChange={setShowFilterDialog}
          huidigFilter={currentFilter}
          setNieuwFilter={setCurrentFilter}
        />
      )}
    </div>
  );
}

export default Signalen;
